import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LadipageComponent } from './components/ladipage/ladipage.component';

const routes: Routes = [
  {
    path: '',
    children: [
      { path: '', component: LadipageComponent },
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LadipageRoutingModule { }
